import { createReducer } from '@reduxjs/toolkit';
import { getAllIndustryCategoriesAction } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllIndustryCategoriesAction, (state, action) => {
    state.list = action.payload;
  })
);
